import {WeekProps} from '../views/Week'
import {DateNavigator} from './DateNavigator'

interface WeekDateBtnProps {
  selectedDate: Date
  onChange(value: Date, key: 'selectedDate'): void
  weekProps: WeekProps
}

const WeekDateBtn = ({selectedDate, onChange, weekProps}: WeekDateBtnProps) => (
  <DateNavigator
    unit='week'
    selectedDate={selectedDate}
    weekStartOn={weekProps.weekStartOn}
    onChange={onChange}
  />
)

export {WeekDateBtn}
